var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-edit"},[_c('button',{staticClass:"btn",class:{'no-editing-permission' : !_vm.editingPermission},attrs:{"type":"button"}},[_c('IconEdit',{attrs:{"width":"25px","height":"25px"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }